/* eslint-disable react-hooks/exhaustive-deps */
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";
import "../style/customInput.css";
import { v4 as uuidv4 } from "uuid";
import { Button, Collapse, Form, Image, Input, message, Modal, Select, Spin, Tooltip } from "antd";
import { Checkbox } from "antd";
import EmailTemplateModal from "../../Common/components/EmailTemplateModal";
import ContentEditable from "../../Common/components/ContentEditable";
import AddEmail from "../../Common/components/AddEmail";
import { offerTableHandle } from "../../OfferTable/state/actions";
import { EyeOutlined, WarningOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import DocumentList from "./DocumentList";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import { TiContacts } from "react-icons/ti";
import { ClientList } from "../../CreateOffer/components/ClientList";
import { detectMobile, detectWebView, generateFullNameFromObj, getcombinedClientsAndAgents, mapClientsForSendEmail, validateEmail } from "../utils/universalFuntions";
import { calendarHandle } from "../../CalenderComponent/state/actions";
import RecipientList from "./RecipientList";
import styles from "../style/SendEmailModal.module.css";
import SubjectLine from "./SubjectLine";
import confirm from "antd/lib/modal/confirm";
import { getCombinedAgentsData, getCombinedTitleCompanyData } from "../../Rtd/utils/rtdHepler";
import GroupedRecipientList from "./GroupedRecipientList";
import { processNestedDataforReadOnly, processSelectedAgentsData } from "../utils/sendEmailHelper";
import { customerDocsContractTypes } from "../commondata/commonData";
import SelectedDocumentList from "./SelectedDocumentList";
import AddEmailSellerAgentWyoming from "./AddEmailSellerAgentWyoming";

const { Option } = Select;

// This is the new design in send document
const SendEmailModal = ({ role, newState, setNewState, initialMountRef, setShowTextArea, showTextArea, selectedData, isEmailModalVisible, documentId, setIsEmailModalVisible, source, isSmallScreen, isMediumScreen, userAuthKey, RTDInitiater, offerId, rootDocData, getTransactionLaneLoading, setCallPropertyDocsApi, propertyAddress }) => {
  const [clientsArray, setClientsArray] = useState([]);
  const [signerChecked, setSignerChecked] = useState({});

  const [selectedPersonsState, setSelectedPersonsState] = useState({
    agents: false,
    titleRepsData: [],
    affiliatesData: [],
    agentsData: [],
  });

  const [showClientListModal, setShowClientListModal] = useState(false);
  const [emailList, setEmailList] = useState({
    emailMessage: "",
  });
  const handleGroupCheckboxSelcted = (checkedObj) => {
    setSelectedPersonsState((prevState) => ({ ...prevState, ...checkedObj }));
  };

  const [data, setData] = useState({
    documentSelected: [],
    propertyDocsSelected: [],
    sharedSelected: [],
    clientDocumentSelected: [],
    customerDocumentSelected: [],
    documentWithoutBuyerSelected: [],
    documentNames: [],
  });
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [subjectForm] = Form.useForm();
  const [isSellerAgentEmail,setIsSellerAgentEmail] = useState(false)

  // const { emailPreviewData, emailPreviewLoading } = useSelector((state) => state.contractStore);
  const { addEmailLoading } = useSelector((state) => state.rtdTransactionLane);
  const { getIndividualTransactionData, getIndividualTransactionLoading } = useSelector((state) => state.rtdTransactionLane);
  const { loadOpacityLoader } = useSelector((state) => state.app);
  const { propertyDocs, contactDocs, propertDocsLoading, personDocs, personDocsLoading } = useSelector((state) => state.createOffer, shallowEqual);

  const mapClientDocs = (docsTabDoraDocs) => {
    let clientDocuments = [];
    docsTabDoraDocs?.forEach((doc) => {
      if (doc.createdDocuments?.length > 0) {
        doc.createdDocuments.forEach((subDoc) => {
          clientDocuments.push(subDoc);
          if (subDoc.matchedDocuments?.length > 0) {
            subDoc.matchedDocuments.forEach((matchDocument) => {
              clientDocuments.push(matchDocument);
            });
          }
        });
      }
    });

    return clientDocuments;
  };
  const clientDocs = mapClientDocs(personDocs);
  const isClientDoc = customerDocsContractTypes.includes(rootDocData?.contractType);
  const [enterEmailModal, setEnterEmailModal] = useState({
    visible: false,
    data: {},
    inValid: false,
  });
  const breakPoint = useMediaQuery({ maxWidth: "573px" });

  const [clickedDataEmail, setClickedDataEmail] = useState({});
  const [Email_templatevisible, setEmail_templatevisible] = useState(false);
  const [emailSignatureId, setEmailSignatureId] = useState({});
  const [emailPreviewClients, setEmailPreviewClients] = useState([]);
  const [ispreview, setIspreview] = useState({
    signaturePreview: false,
    emailPreview: false,
  });
  const [selectedtext, setSelectedText] = useState("");
  const { offerTablePropertyId, offerTableAuthKey, offerTableData, currentSellerAgentData } = useSelector((state) => state.offerTable);
  const { emailPreviewData } = useSelector((state) => state.contractStore);
  const { emailSignData, emailSignLoading } = useSelector((state) => state.commonReducer);
  const [COFormPresent, setCOFormPresent] = useState(false);
 
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const defaultSignVal = emailSignData?.find((sign) => sign.isDefault === true) || { isDefault: false, _id: "" };
      setEmailSignatureId({ ...defaultSignVal });
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      setEmailSignatureId({ checked: false, value: "" });
    };
  }, [emailSignData]);

  const combinedClientsData = useMemo(() => {
    const data = getcombinedClientsAndAgents({
      allContractDocuments: personDocs?.length > 0 ? clientDocs : propertyDocs || [],
      condition: rootDocData?.contractType?.startsWith("HH_") ? null : source === "TRANSACTION_CALENDAR" ? (rootDocData?.openFor === "BUYER_AGENT" ? "BUYER" : rootDocData?.openFor === "SELLER_AGENT" ? "SELLER" : rootDocData?.openFor) : role === "BUYER" ? "BUYER" : "SELLER",
      isClientDoc,
      currentAgentId: rootDocData?.builtForId,
      contractType: rootDocData?.contractType,
    });
    return {
      combinedBuyerIds: data.combinedBuyerIds,
      combinedSellerIds: data.combinedSellerIds,
      combinedSameSideAgents: data.combinedSameSideAgents,
    };
  }, [propertyDocs, clientDocs, role]);
  // console.log("combinedClientsData", combinedClientsData, source);
  const allBuyerAgentData = useMemo(() => {
    const data = [];
    getCombinedAgentsData({ getIndividualTransactionData, agentData: getIndividualTransactionData?.buyerAgentIds, agentList: data, agentType: "BuyerAgents" });
    return data;
  }, [getIndividualTransactionData]);

  const allSellerAgentData = useMemo(() => {
    const data = [];
    getCombinedAgentsData({ getIndividualTransactionData, agentData: getIndividualTransactionData?.sellerAgentIds, agentList: data, agentType: "SellerAgents", origin: getIndividualTransactionData?.stateAbbr === "WY" ? "WY" : "" });
    return data;
  }, [getIndividualTransactionData]);

  const combinedTitleCompanyData = useMemo(() => {
    return getCombinedTitleCompanyData({ getIndividualTransactionData, source });
  }, [getIndividualTransactionData, source]);

  const allContactAgentData = useMemo(() => {
    if (isClientDoc || !contactDocs) return [];
    const { combinedSameSideAgents } = getcombinedClientsAndAgents({ allContractDocuments: contactDocs, condition: true, isClientDoc: true, currentAgentId: rootDocData?.builtForId || currentSellerAgentData?._id });
    return combinedSameSideAgents;
  }, [contactDocs]);

  useEffect(() => {
    const COForm = propertyDocs?.filter((doc) => doc?.contractType === "CO");
    if (COForm?.length > 0) {
      setCOFormPresent(true);
    } else {
      setCOFormPresent(false);
    }
  }, [propertyDocs]);

  useEffect(() => {
    let tempArr = [];
    switch (source) {
      case "SELLING_RTD":
        tempArr = mapClientsForSendEmail({ clients: combinedClientsData.combinedSellerIds, role: "SELLER" });
        break;
      case "CONTRACT_NAV_SELLER_AGENT":
        if (rootDocData?.contractType?.startsWith("HH_")) {
          tempArr = [...mapClientsForSendEmail({ clients: combinedClientsData.combinedBuyerIds, role: "BUYER" }), ...mapClientsForSendEmail({ clients: combinedClientsData.combinedSellerIds, role: "SELLER" })];
        } else {
          tempArr = mapClientsForSendEmail({ clients:  combinedClientsData.combinedSellerIds, role: "SELLER" });
        }
        break;
      case "CONTRACT_NAV_BUYER_AGENT":
        if (rootDocData?.contractType?.startsWith("HH_")) {
          tempArr = [...mapClientsForSendEmail({ clients: combinedClientsData.combinedBuyerIds, role: "BUYER" }), ...mapClientsForSendEmail({ clients: combinedClientsData.combinedSellerIds, role: "SELLER" })];
        } else {
          tempArr = mapClientsForSendEmail({ clients: combinedClientsData.combinedBuyerIds, role: "BUYER" });
        }
        break;
      case "SHARE_INDIVIDUAL_OFFER":
        tempArr = mapClientsForSendEmail({ clients: selectedData?.sellerIds, role: "SELLER" });
        break;
      case "SHARE_OMD":
        tempArr = mapClientsForSendEmail({ clients: selectedData, role: "SELLER" });
        break;
      case "SEND_EMAIL_BUYER_AGENT":
        offerTableData?.forEach((data) => {
          const agents = data?.buyerAgentIds?.length > 0 ? data?.buyerAgentIds : data?.transactionData?.BuyerAgents || [];
          agents?.forEach((agent) => {
            const fullName = agent?.fullName || "";
            const email = agent?.email || "";
            const combinedId = (fullName?.toLowerCase().replace(/\s+/g, "") || "") + "-" + (email?.toLowerCase() || "");
            const buyerAgentId = agent?._id || combinedId;

            // Check if tempDuplicateKey already exists in tempArr
            const isDuplicate = tempArr?.some((item) => item?.tempDuplicateKey === combinedId);

            if (!isDuplicate) {
              tempArr.push({
                fullName: fullName,
                isCorp: false,
                openFor: "BUYER_AGENT",
                personId: {
                  email: email,
                  fullName: fullName,
                  _id: buyerAgentId,
                },
                signers: [],
                _id: buyerAgentId,
                tempDuplicateKey: combinedId,
              });
            }
          });
        });
        tempArr?.forEach((item) => delete item?.tempDuplicateKey);
        break;
      case "TRANSACTION_CALENDAR":
        let role = rootDocData?.openFor === "BUYER_AGENT" ? "BUYER" : rootDocData?.openFor === "SELLER_AGENT" ? "SELLER" : rootDocData?.openFor;
        tempArr = mapClientsForSendEmail({ clients: rootDocData?.openFor === "SELLER_AGENT" ? combinedClientsData.combinedSellerIds : combinedClientsData.combinedBuyerIds, role });
        break;
      default:
        tempArr = selectedData?.acceptedOfferSellers?.map((seller) => ({
          openFor: "SELLER",
          seller: seller?.fullName || null,
          key: seller?._id || null,
          name: seller?.fullName || null,
          emailPresent: !!seller?.email,
          email: seller?.email || null,
        }));
        break;
    }
    setClientsArray(tempArr);
    const initialChecked = {};
    tempArr?.forEach((seller) => {
      initialChecked[seller._id] = { checked: COFormPresent ? false : !!seller.personId?.email, row: seller };
      if (seller?.isCorp) {
        seller?.signers?.forEach((signer) => {
          initialChecked[signer._id] = { checked: COFormPresent ? false : !!signer.personId?.email, row: signer };
        });
      }
    });
    setSignerChecked(initialChecked);
    return () => {
      initialMountRef.current = false;
    };
  }, [selectedData, source, isEmailModalVisible, propertyDocs, personDocs, COFormPresent]);

  useEffect(() => {
    if (!initialMountRef.current && Object.keys(signerChecked)?.length > 0) {
      if (COFormPresent) {
        handleSelectAllChange(false);
      } else {
        handleSelectAllChange(true);
      }
      initialMountRef.current = true;
    }
  }, [signerChecked, isEmailModalVisible]);

  const isButtonDisabled = () => {
    const noSignersChecked = Object.values(signerChecked).every((el) => !el.checked);
    const noEmailMessage = !emailList?.emailMessage || emailList?.emailMessage === "<p><br></p>";
    const noDocumentsSelected = !(data?.documentSelected?.length || data?.propertyDocsSelected?.length || data?.sharedSelected?.length || data?.clientDocumentSelected?.length || data?.customerDocumentSelected?.length || data?.documentWithoutBuyerSelected?.length);

    if (source === "SEND_EMAIL_BUYER_AGENT") {
      return noEmailMessage || noSignersChecked;
    }
    if (isEmailModalVisible?.sendMultipleDoc) {
      if (["SELLING_RTD", "CONTRACT_NAV_BUYER_AGENT", "CONTRACT_NAV_SELLER_AGENT"].includes(source)) {
        const hasTitleReps = combinedTitleCompanyData?.titleRepsData?.length > 0;
        const hasAffiliates = combinedTitleCompanyData?.affiliatesData?.length > 0;
        const hasAgents = combinedClientsData?.combinedSameSideAgents?.length > 0;
        const hasCustomerAgents = allContactAgentData?.length > 0;
        const noValidSelections = (!hasCustomerAgents || !selectedPersonsState?.agentsData?.length) && (!hasTitleReps || !selectedPersonsState?.titleRepsData?.length) && (!hasAffiliates || !selectedPersonsState?.affiliatesData?.length) && (!hasAgents || !selectedPersonsState?.agentsData?.length);
        return (!selectedPersonsState?.agents && noValidSelections && noSignersChecked) || (noEmailMessage && noDocumentsSelected);
      }
      return noSignersChecked || (noEmailMessage && noDocumentsSelected);
    }
    return noSignersChecked;
  };

  const { Panel } = Collapse;
  const handleInput = (event) => {
    setEmailList({
      ...emailList,
      emailMessage: event.target.innerHTML,
    });
  };
  const handleselectemail = (value) => {
    <div dangerouslySetInnerHTML={{ __html: selectedtext }} />;
    setSelectedText(value);
    setEmailList({
      ...emailList,
      emailMessage: value,
    });
    setEmail_templatevisible(false);
  };
  const handleEmail_templateCancel = () => {
    setEmail_templatevisible(false);
  };

  const handleEmailCancel = () => {
    if (["CONTRACT_NAV_BUYER_AGENT", "CONTRACT_NAV_SELLER_AGENT", "SELLING_RTD"].includes(source)) {
      setIsEmailModalVisible({ ...isEmailModalVisible, isEmailModalOpen: false, sendMutipleDoc: false });
    } else {
      setIsEmailModalVisible(false);
    }
    setEmailList({
      ...emailList,
      emailMessage: "",
    });
    setSelectedText("");
    setSignerChecked({});
  };

  //validate read only emails
  // const validateEmail = (email) => {
  //   email = email.trim(); // Remove leading and trailing whitespace
  //   const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   return re.test(email);
  // };

  const handleReadOnlyEmailChange = (e) => {
    const value = e.target.value;
    setNewState({ ...newState, email: value });
  };

  const handleSend = (emailPreview) => {
    try {
      let arr = [];
      if (emailPreview === "emailPreview") {
        arr = Object.values(signerChecked)
          .filter((el) => el.checked && !el?.isReadOnly && !el?.isAddedByUser)
          .map((el) => ({
            ...(el?.row?.personId?._id ? { clientId: el?.row?.personId?._id } : {}),
            ...(el?.row?.openFor ? { openFor: el?.row?.openFor } : {}),
            ...(el?.row?.isCorp ? { key: el?.row?.corpKey } : el?.row?.personId?._id ? { key: el?.row?.personId?._id } : {}),
            //for email preview
            ...(el?.row?.isCorp ? { isCorp: true } : {}),
            ...(el?.row?.isCorp ? { clientType: "Corp_Client" } : el?.row?.personId?._id ? { clientType: "Client" } : {}),
            ...(el?.row?.isCorp ? { corpName: el?.corpName } : {}),
          }))
          .filter((el) => Object.keys(el).length !== 0);
      } else {
        arr = Object.values(signerChecked)
          .filter((el) => el.checked && !el?.isReadOnly && !el?.isAddedByUser)
          .map((el) => ({
            ...(el?.row?.personId?._id ? { clientId: el?.row?.personId?._id } : {}),
            ...(el?.row?.openFor ? { openFor: el?.row?.openFor } : {}),
            ...(el?.row?.isCorp ? { key: el?.row?.corpKey } : el?.row?.personId?._id ? { key: el?.row?.personId?._id } : {}),
          }))
          .filter((el) => Object.keys(el).length !== 0);
      }
      const readonlyClients = processNestedDataforReadOnly(clientsArray, selectedPersonsState, emailPreview) || [];
     
      const subjectVal = subjectForm?.getFieldValue("subject");
      const defaultBasePaylod = {
        clientArray: arr.filter((el) => el.openFor),
        ...(emailList?.emailMessage && { emailMessage: emailList.emailMessage.charAt(0).toUpperCase() + emailList.emailMessage.slice(1) }),
        ...(emailSignatureId?.isDefault && emailSignatureId?._id && { emailSignatureId: emailSignatureId._id }),
        ...(subjectVal?.length && { subject: subjectVal }),
      };
    
      let payloadData = {};

      if (source === "SHARE_INDIVIDUAL_OFFER") {
        payloadData = {
          ...defaultBasePaylod,
          ...(emailPreview === "emailPreview" ? { showEmailPreview: true } : {}),
          propertyId: offerTablePropertyId,
          offerId: selectedData?.offerId,
          sellerOpenOfferTable: true,
          sharedIndividualOffer: true,
          openFor: "SELLER_AGENT"
        };
        dispatch(offerTableHandle.shareOfferTableToClients(offerTableAuthKey, payloadData, emailPreview));
      } else if (source === "SHARE_OMD") {
        payloadData = {
          ...defaultBasePaylod,
          ...(emailPreview === "emailPreview" ? { showEmailPreview: true } : {}),
          propertyId: offerTablePropertyId,
          sellerOpenOfferTable: true,
          openFor: "SELLER_AGENT"
        };
        dispatch(offerTableHandle.shareOfferTableToClients(offerTableAuthKey, payloadData, emailPreview));
      } else if (source === "TRANSACTION_CALENDAR") {
        payloadData = {
          ...defaultBasePaylod,
          ...(emailPreview === "emailPreview" ? { showEmailPreview: true } : {}),
          ...(readonlyClients.length ? { readOnlyEmailsArray: readonlyClients } : {}),
          offerId: rootDocData?.offerId,
          openFor: rootDocData?.openFor,
          propertyId: rootDocData?.propertyId,
        };
        dispatch(calendarHandle.shareCalendarToClients({ payloadData, userAuthKey, emailPreview }));
      } else if (source === "SEND_EMAIL_BUYER_AGENT") {
        const isObjectId = (id) => typeof id === 'string' && /^[a-f0-9]{24}$/.test(id.trim());
        delete defaultBasePaylod.clientArray;
        const clientArray = arr.filter((item) => item.clientId && item.key && isObjectId(item.clientId) && isObjectId(item.key));
        const readOnlyEmailsArray = Object.values(signerChecked).reduce((acc, item) => {
          const id = item?.row?.personId?._id;
          if (item.checked && !isObjectId(id)) {
            const fullName = item?.row?.personId?.fullName;
            const email = item?.row?.personId?.email;
            if (fullName || email) {
              acc.push({ fullName, email });
            }
          }
          return acc;
        }, []);
        payloadData = {
          ...defaultBasePaylod,
          ...(emailPreview === "emailPreview" ? { showEmailPreview: true } : {}),
          ...(clientArray.length > 0 ? { clientArray } : {}),
          ...(readOnlyEmailsArray.length > 0 ? { readOnlyEmailsArray } : {}),
          propertyId: offerTablePropertyId,
          sentBy: "SELLER_AGENT",
          openFor: "SELLER_AGENT"
        };
        dispatch(offerTableHandle.shareMessageToBuyerAgents({ offerTableAuthKey, payloadData, sourceType: emailPreview }));
      } else if (["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT"].includes(source)) {
        const sameSideAgentsArray = processSelectedAgentsData(selectedPersonsState?.agentsData);
        let params = {};
        if (source === "CONTRACT_NAV_SELLER_AGENT" || source === "CONTRACT_NAV_BUYER_AGENT") {
          params = {
            ...defaultBasePaylod,
            ...(readonlyClients.length ? { readOnlyEmailsArray: readonlyClients } : {}),
            ...(sameSideAgentsArray?.length ? (isClientDoc ? { sameSideAgentsArray } :{ allCustomerDocAgents: sameSideAgentsArray }) : {}),
            ...(data?.documentSelected?.length ? { documentIds: [...data?.documentSelected] } : {}),
            ...(data?.sharedSelected?.length ? { sharedFolderDocsArray: [...data?.sharedSelected] } : {}),
            ...(data?.resureSignSelected?.length ? { resureSignDocsArray: data.resureSignSelected } : {}),
            ...(data?.propertyDocsSelected.length || data?.documentWithoutBuyerSelected.length
              ? {
                propertyDocsArray: [...(data?.propertyDocsSelected || []), ...(data?.documentWithoutBuyerSelected || [])],
              }
              : {}),
            ...(data?.clientDocumentSelected?.length ? { contactDocArray: [...data?.clientDocumentSelected] } : {}),
            sentBy: source === "CONTRACT_NAV_SELLER_AGENT" ? "SELLER_AGENT" : "BUYER_AGENT",
            openFor: source === "CONTRACT_NAV_SELLER_AGENT" ? "SELLER_AGENT" : "BUYER_AGENT",
            ...(rootDocData?.offerId ? { offerId: rootDocData?.offerId } : {}),
            ...(rootDocData?.propertyId ? { propertyId: rootDocData?.propertyId } : {}),
          };
        } else {
          params = {
            ...defaultBasePaylod,
            ...(readonlyClients.length ? { readOnlyEmailsArray: readonlyClients } : {}),
            ...(readonlyClients?.length ? { readOnlyEmailsArray: readonlyClients } : {}),
            ...(data?.documentSelected?.length ? { documentIds: [...data?.documentSelected] } : {}),
            ...(data?.sharedSelected?.length ? { sharedFolderDocsArray: [...data?.sharedSelected] } : {}),
            ...(sameSideAgentsArray?.length ? (isClientDoc ? { sameSideAgentsArray } :{ allCustomerDocAgents: sameSideAgentsArray }) : {}),
            ...(data?.propertyDocsSelected.length || data?.documentWithoutBuyerSelected.length
              ? {
                propertyDocsArray: [...(data?.propertyDocsSelected || []), ...(data?.documentWithoutBuyerSelected || [])],
              }
              : {}),
            ...(data?.clientDocumentSelected?.length ? { contactDocArray: [...data?.clientDocumentSelected] } : {}),
            sentBy: source === "SELLING_RTD" ? "SELLER_AGENT" : "BUYER_AGENT",
            ...(selectedData?.offerId ? { offerId: selectedData?.offerId } : {}),
            ...(selectedData?.propertyId ? { propertyId: selectedData?.propertyId } : {}),
            openFor: source === "SELLING_RTD" ? "SELLER_AGENT" : "BUYER_AGENT"
          };
        }
        if (emailPreview === "emailPreview") {
          params = {
            ...params,
            showEmailPreview: true,
          };
        }
        if (data?.customerDocumentSelected?.length) {
          params = {
            ...params,
            propertyDocsArray: [...(params?.propertyDocsArray || []), ...data?.customerDocumentSelected],
          };
        }

        if ((selectedPersonsState?.agents || (isClientDoc && sameSideAgentsArray.length > 0)) && ["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT"].includes(source) && emailPreview === "emailPreview") {
          const updatedParams = {
            ...params,
            ...(["CONTRACT_NAV_BUYER_AGENT"].includes(source) && allSellerAgentData?.length > 0 ? { sendToAgent: "SELLER_AGENT" } : {}),
            ...(["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT"].includes(source) && allBuyerAgentData?.length > 0 ? { sendToAgent: "BUYER_AGENT" } : {}),
          };
          const callIndividualTransactionApi = source === "SELLING_RTD" ? true : false;
          dispatch(contractStoreHandle.SendMultipleDoc(updatedParams, userAuthKey, callIndividualTransactionApi, emailPreview));
        } else if ((selectedPersonsState?.agents || (isClientDoc && sameSideAgentsArray.length > 0)) && ["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT"].includes(source)) {
          const agentsData = isClientDoc && sameSideAgentsArray.length > 0 ? sameSideAgentsArray : ["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT"].includes(source) && allBuyerAgentData?.length > 0 ? allBuyerAgentData : ["CONTRACT_NAV_BUYER_AGENT"].includes(source) && allSellerAgentData?.length > 0 ? allSellerAgentData : [];
          const modal = confirm({
            title: (
              <div className={styles.confirmTitle}>
                <div>
                  Are you sure you want to send the selected document{params?.propertyDocsArray?.length > 1 ? "s" : ""} to the following agent{agentsData?.length > 1 ? "s" : ""}?
                </div>
                <span
                  style={{
                    position: "absolute",
                    top: "2px",
                    right: "10px",
                    cursor: "pointer",
                    fontSize: "25px",
                    color: "grey",
                    borderRadius: "50%",
                    padding: "5px",
                  }}
                  onClick={() => modal.destroy()}
                >
                  x
                </span>
              </div>
            ),
            okText: "Yes",
            cancelText: "No",
            width: 700,
            icon: <ExclamationCircleOutlined style={{ marginRight: "8px", fontSize: "18px", color: "orange" }} />,
            content: <div className={styles.confirmModalContent}>
              <RecipientList data={agentsData} sourcePlace="CONFIRM_MODAL" />
              <SelectedDocumentList data={data} sourcePlace="CONFIRM_MODAL" />
            </div>,
            onOk() {
              const updatedParams = {
                ...params,
                ...(["CONTRACT_NAV_BUYER_AGENT"].includes(source) && allSellerAgentData?.length > 0 ? { sendToAgent: "SELLER_AGENT" } : {}),
                ...(["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT"].includes(source) && allBuyerAgentData?.length > 0 ? { sendToAgent: "BUYER_AGENT" } : {}),
              };
              const callIndividualTransactionApi = source === "SELLING_RTD" ? true : false;
              dispatch(contractStoreHandle.SendMultipleDoc(updatedParams, userAuthKey, callIndividualTransactionApi, emailPreview));
            },
            onCancel() {
              if (arr.length <= 0 && readonlyClients.length <= 0) {
                message.error("Please add at least one recipient.");
              } else {
                dispatch(contractStoreHandle.SendMultipleDoc(params, userAuthKey, false, emailPreview));
              }
            },
          });
        } else {
          if (emailPreview === "emailPreview") {
            dispatch(contractStoreHandle.SendMultipleDoc(params, userAuthKey, false, emailPreview));
          } else {
            dispatch(contractStoreHandle.SendMultipleDoc(params, userAuthKey));
          }
        }
      } else {
        payloadData = {
          ...defaultBasePaylod,
          documentId,
          ...(emailPreview === "emailPreview" ? { showEmailPreview: true } : {}),
          ...(selectedData?.propertyId ? { propertyId: selectedData?.propertyId } : {}),
          ...(selectedData?.offerId ? { offerId: selectedData?.offerId } : {}),
        };
        dispatch(transactionLaneDataHandle.sendEmailToClients(payloadData, emailPreview));
      }
      if (emailPreview !== "emailPreview") {
        handleEmailCancel();
      }
    } catch (error) { 
      console.log("error in send email:", error);
    }
  };
  // console.log("clickedDataEmail", clickedDataEmail);
  const handleAddEmail = (values, check) => {
    let documentId = rootDocData?.documentId;
    let data;
    if (!enterEmailModal?.inValid) {
      data = {
        addToProperty: false,
        offerId: ["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT", "TRANSACTION_CALENDAR"].includes(source) ? offerId : selectedData?.offerId,
        ...(source === "CONTRACT_NAV_BUYER_AGENT" || (source === "TRANSACTION_CALENDAR" && rootDocData?.openFor === "BUYER_AGENT")
          ? {
              buyerDetail: {
                fullName: clickedDataEmail?.personId?.fullName ? clickedDataEmail?.personId?.fullName : clickedDataEmail?.fullName,
                ...(clickedDataEmail?.personId?._id
                  ? {
                      personId: clickedDataEmail?.personId?._id,
                    }
                  : {
                      key: clickedDataEmail?.key ? clickedDataEmail?.key : clickedDataEmail?._id,
                      isCorp: clickedDataEmail?.isCorp,
                      corpKey: clickedDataEmail.corpKey,
                    }),
                ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
              },
              openFor: "BUYER_AGENT"
            }
          : {
              sellerDetail: {
                fullName: clickedDataEmail?.personId?.fullName ? clickedDataEmail?.personId?.fullName : clickedDataEmail?.fullName,
                ...(clickedDataEmail?.personId?._id
                  ? {
                      personId: clickedDataEmail?.personId?._id,
                    }
                  : {
                      key: clickedDataEmail?.key ? clickedDataEmail?.key : clickedDataEmail?._id,
                      isCorp: clickedDataEmail?.isCorp,
                      corpKey: clickedDataEmail.corpKey,
                    }),
                ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
              },
              openFor: "SELLER_AGENT"
            }),
        ...(values?._id ? { selectedId: values?._id } : {}),
        ...(check ? { newClient: true } : {}),
      };
      dispatch(transactionLaneDataHandle.addEmailFun({ data, userAuthKey, source, setEnterEmailModal, enterEmailModal, documentId, setIsEmailModalVisible, isEmailModalVisible, setCallPropertyDocsApi, form }));
    } else {
      data = {
        ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
      };
      dispatch(transactionLaneDataHandle.updateEmail(data, clickedDataEmail?.personId?._id, userAuthKey, offerTablePropertyId, source));
    }
    setEnterEmailModal({ ...enterEmailModal, visible: false });
  };
  const handleSelectAllChange = (checked) => {
    const updatedSignerChecked = {};
    clientsArray?.forEach((seller) => {
      if (!seller.isCorp && seller.personId?.email && validateEmail(seller?.personId?.email)) {
        updatedSignerChecked[seller._id] = { checked, row: seller };
      } else if (seller.isCorp) {
        seller?.signers?.forEach((signer) => {
          if (signer?.personId?.email && validateEmail(signer?.personId?.email)) {
            updatedSignerChecked[signer._id] = { checked, row: signer, corpName: seller.fullName };
          }
        });
      }
    });
    setSignerChecked(updatedSignerChecked);
  };

  const handleClientsCheckboxChange = (sellerId, checked) => {
    setSignerChecked((prev) => ({
      ...prev,
      [sellerId]: { checked, row: prev[sellerId]?.row },
    }));
  };

  const CorporationCheckbox = ({ corporation = {} }) => {
    const [isCorpChecked, setIsCorpChecked] = useState(() => {
      const isInitiallyChecked = corporation?.signers?.every((signer) => signer?.personId?.email && validateEmail(signer?.personId?.email) && signerChecked[signer._id]?.checked);
      return isInitiallyChecked || false;
    });
    const handleCheckboxChange = (signerId, checked) => {
      setSignerChecked((prev) => ({
        ...prev,
        [signerId]: { checked, row: prev[signerId]?.row },
      }));
      if (corporation?.signers) {
        // Checking if all child checkboxes are checked
        const allChildChecked = corporation.signers.every((signer) => signer?.personId?.email && validateEmail(signer?.personId?.email) && signerChecked[signer._id]?.checked);
        // Updating the state of the parent checkbox
        setIsCorpChecked(allChildChecked);
      }
    };

    const handleParentCheckboxChange = (checked) => {
      setIsCorpChecked(checked);
      if (corporation?.signers) {
        corporation.signers.forEach((signer) => {
          if (signer?.personId?.email && validateEmail(signer?.personId?.email)) {
            setSignerChecked((prev) => ({
              ...prev,
              [signer._id]: { checked, row: prev[signer._id]?.row },
            }));
          }
        });
      }
    };
    const handleUpdateReadOnlyCorp = (signerId, checked) => {
      const updatedReadOnly = checked;

      setClientsArray((prevData) =>
        prevData.map((client) => {
          if (client.signers && client.signers.length > 0) {
            const updatedSigners = client.signers.map((signer) => (signer._id === signerId ? { ...signer, isReadOnly: updatedReadOnly } : signer));
            return { ...client, isReadOnly: updatedReadOnly, signers: updatedSigners };
          }
          return client;
        })
      );

      setSignerChecked((prev) => ({
        ...prev,
        [signerId]: { checked: true, row: prev[signerId]?.row, isReadOnly: checked },
      }));
    };

    return (
      <div>
        <div className={styles.signlePersonRow}>
          <Checkbox checked={isCorpChecked} onChange={(e) => handleParentCheckboxChange(e.target.checked)} />
          <div className={styles.fullName} style={{ color: "orange" }}>
            {corporation?.fullName || ""} {"Signers"}
          </div>
        </div>
        {corporation?.signers?.map((signer) => (
          <div className={styles.signlePersonRow} style={{ marginLeft: "28px" }} key={signer?._id}>
            <Checkbox checked={signerChecked[signer._id]?.checked} onChange={() => handleCheckboxChange(signer._id, !signerChecked[signer._id]?.checked)} disabled={!signer?.personId?.email || !validateEmail(signer?.personId?.email)} />
            <div>
              <span className={styles.fullName}>{signer?.fullName}</span>
              <span className={styles.dash}>-</span>
              <span className={styles.email}>
                {signer?.personId?.email && validateEmail(signer?.personId?.email) ? (
                  <span className={styles.email}>
                    {signer.personId.email}
                    {["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT", "SELLING_RTD", "TRANSACTION_CALENDAR"].includes(source) && (
                      <span style={breakPoint ? { fontSize: "10px", marginLeft: "5px" } : { marginLeft: "10px" }}>
                        <Checkbox checked={signerChecked[signer._id]?.isReadOnly} onChange={(event) => handleUpdateReadOnlyCorp(signer._id, event.target.checked)}>
                          <span className={styles.readOnly}>Read Only</span>
                        </Checkbox>
                      </span>
                    )}
                  </span>
                ) : signer?.personId?.email && !validateEmail(signer?.personId?.email) ? (
                  <>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setClickedDataEmail(signer);
                        setEnterEmailModal({ ...enterEmailModal, visible: true, inValid: true });
                        form?.setFieldsValue({ email: signer?.personId?.email });
                      }}
                    >
                      <span style={{ fontSize: isSmallScreen ? "12px" : isMediumScreen ? "14px" : "18px", color: "blue", textDecoration: "underline" }}>{signer?.personId?.email}</span>
                      <Tooltip title="This email is not valid. Please enter a valid email.">
                        <span>
                          <WarningOutlined style={{ color: "orange", fontSize: "18px", marginLeft: "8px" }} />
                        </span>
                      </Tooltip>
                    </span>
                  </>
                ) : (
                  <button
                    onClick={() => {
                      setClickedDataEmail(signer);
                      setEnterEmailModal({ ...enterEmailModal, visible: true });
                    }}
                    style={{ fontSize: isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px", backgroundColor: "#1890ff", color: "white", border: "none", borderRadius: "2px", cursor: "pointer" }}
                  >
                    Add Email
                  </button>
                )}
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  };
  const handleDeleteReadOnly = (id) => {
    let clients = clientsArray || [];

    let tobeDelete = clients.find((client) => client?.personId?._id === id && client.isReadOnly);
    if (tobeDelete) {
      let updatedClients = clients.filter((client) => !(client?.personId?._id === id && client.isReadOnly));

      setClientsArray(updatedClients);

      let updatedSignerChecked = { ...signerChecked };
      delete updatedSignerChecked[id];
      setSignerChecked(updatedSignerChecked);

      message.success("Read only recipient deleted successfully.");
    } else {
      message.error("Read only recipient not found.");
    }
  };
  const handleUpdateReadOnly = (selectedClient, checked) => {
    const updatedReadOnly = checked;

    setClientsArray((prevData) => prevData.map((client) => (client?._id === selectedClient?._id ? { ...client, isReadOnly: updatedReadOnly } : client)));

    setSignerChecked((prevState) => ({
      ...prevState,
      [selectedClient?._id]: {
        ...prevState[selectedClient?._id],
        isReadOnly: updatedReadOnly,
        isAddedByUser: false,
      },
    }));
  };
  const handleReadOnlyNameChange = (e) => {
    const value = e.target.value;
    // Filter out empty strings
    setNewState({ ...newState, fullName: value });
    // Update the state with the array of emails
  };
  const handleSelectChange = (id) => {
    let [filteredValue] = emailSignData
      ?.filter((el) => el?._id === id)
      .map((el) => {
        return { ...el, isDefault: true };
      });
    setEmailSignatureId(filteredValue);
  };
  const handleEmailAddress = () => {
    const email = newState?.email?.toLowerCase()?.trim();
    const fullName = newState?.fullName?.trim();
    const alreadyAddedEmail = clientsArray?.find((client) => client?.isReadOnly && client?.personId?.email === email);
    if(alreadyAddedEmail){
      message.error("Email already exists in the list.");
      return;
    }
    // Check if email and name are provided
    if (email && fullName) {
      // Generate a unique ID for each email
      let uniqueEmailId = uuidv4().replace(/-/g, "").slice(0, 26);

      let data = {
        personId: {
          email: email,
          fullName: fullName, // Include the name here
          _id: uniqueEmailId,
        },
        isReadOnly: true,
        isAddedByUser: true,
        _id: uniqueEmailId,
      };
      let signerData = {
        checked: true,
        isReadOnly: true,
        isAddedByUser: true,
        row: {
          personId: {
            email: email,
            fullName: fullName, 
            _id: uniqueEmailId,
          },
          _id: uniqueEmailId,
        },
      };
      // Update state
      setClientsArray((prevArray) => [...prevArray, data]);
      setSignerChecked((prevChecked) => ({ ...prevChecked, [uniqueEmailId]: signerData }));

      // Reset email and name values
      setNewState({ email: "", fullName: "" }); // Reset email and name fields
      form.resetFields();
    }
    setShowTextArea(false);
  };
  const closeClientListModal = () => {
    setShowClientListModal(false);
    setShowTextArea(false);
    setNewState({ email: "", fullName: "" });
  };
  const checkClient = (data, selectedClient) => {
    for (const client of data) {
      if (client.isCorp) {
        // If isCorp is true, loop over the signers array
        for (const signer of client.signers) {
          if (signer.personId._id === selectedClient._id) {
            return true;
          }
        }
      } else {
        // If isCorp is false, compare personId._id directly
        if (client.personId._id === selectedClient._id) {
          return true;
        }
      }
    }
    return false;
  };
  const addClient = (selectedClient) => {
    const clients = clientsArray || [];

    if (clients.length >= 10) {
      message.error(`Maximum number of clients already added.`);
      return;
    }

    let check = checkClient(clientsArray, selectedClient);

    if (check) {
      message.error(`User already exists in read only recipients list.`);
      return;
    } else {
      setClientsArray([
        ...clientsArray,
        {
          fullName: generateFullNameFromObj(selectedClient),
          personId: { email: selectedClient?.email, _id: selectedClient._id },
          isCorp: false,
          isReadOnly: true,
          isAddedByUser: true,
          _id: selectedClient._id,
          signers: [],
        },
      ]);

      setSignerChecked({
        ...signerChecked,
        [selectedClient._id]: {
          fullName: generateFullNameFromObj(selectedClient),
          personId: { email: selectedClient?.email },
          isCorp: false,
          isReadOnly: true,
          _id: selectedClient._id,
          signers: [],
          checked: true,
        },
      });
      message.success("Read only recipient added successfully.");
    }
  };
  const NormalPersonDetails = ({ person }) => {
    return (
      <div className={styles.signlePersonRow}>
        <Checkbox checked={signerChecked[person._id]?.checked} onChange={() => handleClientsCheckboxChange(person._id, !signerChecked[person._id]?.checked)} disabled={!person.personId?.email || !validateEmail(person?.personId?.email)} />
        <div>
          <span className={styles.fullName}>{person.fullName}</span>
          {person.fullName && <span className={styles.dash}>-</span>}

          {person?.personId?.email && validateEmail(person?.personId?.email) ? (
            <>
              {person.personId?.fullName && person?.isAddedByUser && (
                <>
                  {" "}
                  <span className={styles.fullName}> {person?.personId?.fullName} </span>
                  <span className={styles.dash}>-</span>
                </>
              )}
              <span className={styles.email}>
                {person?.personId?.email}
                {["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT", "SELLING_RTD", "TRANSACTION_CALENDAR"].includes(source) && (
                  <span style={isSmallScreen ? { fontSize: "10px", marginLeft: "5px" } : { marginLeft: "10px" }}>
                    {person?.isAddedByUser ? null : (
                      <Checkbox checked={person?.isReadOnly} onChange={(event) => handleUpdateReadOnly(person, event.target.checked)}>
                        <span className={styles.readOnly}>Read Only</span>
                      </Checkbox>
                    )}
                  </span>
                )}
              </span>
              <span style={{ color: "grey" }}>
                <span className={styles.readOnly}>{person?.isAddedByUser ? "(Read Only)" : ""}</span>
                <span style={{ cursor: "pointer" }}>
                  {"  "}
                  {person?.isAddedByUser && (
                    <Tooltip title="Delete read only recipient" trigger={["hover", "click"]}>
                      <DeleteOutlined onClick={() => handleDeleteReadOnly(person?.personId?._id)} />
                    </Tooltip>
                  )}
                </span>
              </span>
            </>
          ) : person?.personId?.email && !validateEmail(person?.personId?.email) ? (
            <>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setClickedDataEmail(person);
                  setEnterEmailModal({ ...enterEmailModal, visible: true, inValid: true });
                  form?.setFieldsValue({ email: person?.personId?.email });
                }}
              >
                <span style={{ fontSize: isSmallScreen ? "12px" : isMediumScreen ? "14px" : "18px", color: "blue", textDecoration: "underline" }}>{person?.personId?.email}</span>
                <Tooltip title="This email is not valid. Please enter a valid email.">
                  <span>
                    <WarningOutlined style={{ color: "orange", fontSize: "18px", marginLeft: "8px" }} />
                  </span>
                </Tooltip>
              </span>
            </>
          ) : (
            <button
              onClick={() => {
                setClickedDataEmail(person);
                setEnterEmailModal({ ...enterEmailModal, visible: true });
              }}
              style={{ fontSize: isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px", backgroundColor: "#1890ff", color: "white", border: "none", borderRadius: "2px", cursor: "pointer" }}
            >
              Add Email
            </button>
          )}
        </div>
      </div>
    );
  };
  const isInWebView = detectWebView() || detectMobile();

  const handleOpenEmailPreview = () => {
    setIspreview({ ...ispreview, emailPreview: true });

    const arr = Object.values(signerChecked)
      .filter((el) => el.checked)
      .map((el) => ({
        ...(el?.row?.personId?._id ? { clientId: el?.row?.personId?._id } : {}),
        ...(el?.row?.openFor ? { openFor: el?.row?.openFor } : {}),
        ...(el?.row?.isCorp ? { key: el?.row?.corpKey } : el?.row?.personId?._id ? { key: el?.row?.personId?._id } : {}),
        ...(el?.row?.isCorp ? { corpName: el?.corpName } : {}),
        ...(el?.row?.isCorp && !el?.isReadOnly && !el?.isAddedByUser ? { clientType: "Corp_Client" } : el?.isReadOnly || el?.isAddedByUser ? { clientType: "Read_Only_Client" } : el?.row?.personId?._id ? { clientType: "Client" } : {}),
        ...(el?.isReadOnly && el?.isAddedByUser ? { Name: el?.row?.personId?.fullName } :el?.isReadOnly?{Name:el?.fullName}: el?.row?.fullName ? { Name: el?.row?.fullName } : {}),
      }))
      .filter((el) => Object.keys(el).length !== 0);
    setEmailPreviewClients([...arr]);
    handleSend("emailPreview");
  };

  useEffect(() => {
    let allAgent = [];
    if (["BUYING_RTD", "CONTRACT_NAV_BUYER_AGENT"].includes(source) && allSellerAgentData.length > 0 && selectedPersonsState?.agentsData&&selectedPersonsState?.agents) {
      allAgent.push(...allSellerAgentData.map((el) => el?.fullName));
      allAgent.push(...(selectedPersonsState?.agentsData?.map((el) => el?.fullName) || []));
    } else if (["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT"].includes(source) && allBuyerAgentData.length > 0 && selectedPersonsState?.agentsData&&selectedPersonsState?.agents) {
      allAgent.push(...allBuyerAgentData.map((el) => el?.fullName));
      allAgent.push(...(selectedPersonsState?.agentsData?.map((el) => el?.fullName) || []));
    } else {
      allAgent.push(...(selectedPersonsState?.agentsData?.map((el) => el?.fullName) || []));
    }
    if (emailPreviewData && ispreview?.emailPreview) {
      const emailPreviewProps = {
        ispreview,
        clientsArray,
        role,
        allBuyerAgentData,
        allSellerAgentData,
        combinedTitleCompanyData,
        selectedPersonsState,
        subjectForm,
        emailSignatureId,
        emailPreviewClients,
        source,
        combinedSameSideAgents: ["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT"].includes(source) && isClientDoc && combinedClientsData?.combinedSameSideAgents?.length > 0 ? combinedClientsData.combinedSameSideAgents : allContactAgentData,
        emailPreviewData:  emailPreviewData,
        allAgent,
      };
      localStorage.setItem("emailPreviewProps", JSON.stringify(emailPreviewProps));
      if (isInWebView) {
        let emailPreviewPropsData = {
          eventType: "OPEN_EMAIL_PREVIEW",
          emailPreviewProps: emailPreviewProps,
        };
        window?.ReactNativeWebView?.postMessage(JSON.stringify(emailPreviewPropsData));
      } else {
        window.open("/emailPreview", "_blank");
      }

     
    }
  }, [ emailPreviewData]);

  const handleAddEmailClick = (sellerAgentData) => {
    setIsSellerAgentEmail(true);
  }

  return (
    <>
      {/* client list modal  */}
      {showClientListModal && (
        <Modal visible={showClientListModal} onCancel={() => setShowClientListModal(false)} footer={false} style={{ marginTop: "-80px" }}>
          <ClientList source={source === "TRANSACTION_CALENDAR" ? source : "offerTable"} setshowModal={setShowClientListModal} accessTokan={["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT", "TRANSACTION_CALENDAR"].includes(source) ? userAuthKey : offerTableAuthKey} onAdd={addClient} handleCancel={closeClientListModal} openFor={rootDocData?.openFor} />
        </Modal>
      )}
      {ispreview?.signaturePreview && (
        <Modal width={"800px"} visible={ispreview?.signaturePreview} footer={false} onCancel={() => setIspreview({ ...ispreview, signaturePreview: false })}>
          {emailSignatureId && (
            <div
              style={{
                boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                width: "100%",
                borderRadius: "5px",
                padding: "10px",
                margin: "auto",
                marginTop: "10px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <span
                    style={{
                      color: "gray",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    Name: {emailSignatureId?.title}
                  </span>
                </div>
              </div>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  textAlign: "left",
                  lineHeight: "0.8",
                  marginTop: "5px",
                }}
              >
                {emailSignatureId?.footerText && <div dangerouslySetInnerHTML={{ __html: emailSignatureId.footerText }} />}
              </p>

              <div style={{ display: "flex", justifyContent: "center", minHeight: "300px" }}>{emailSignatureId?.signatureImageUrl && <Image src={emailSignatureId?.signatureImageUrl} alt="Signature" loading="lazy" />}</div>
            </div>
          )}
        </Modal>
      )}
      {Email_templatevisible && <EmailTemplateModal Email_templatevisible={Email_templatevisible} setEmail_templatevisible={setEmail_templatevisible} handleEmail_templateCancel={handleEmail_templateCancel} handleselectemail={handleselectemail} />}

      {enterEmailModal && <AddEmail enterEmailModal={enterEmailModal} setEnterEmailModal={setEnterEmailModal} form={form} handleAddEmail={handleAddEmail} clickedDataEmail={clickedDataEmail} role={role} selectedData={selectedData} userAuthKey={userAuthKey} source={source} offerId={offerId} rootDocData={rootDocData} setCallPropertyDocsApi={setCallPropertyDocsApi} />}

      {isSellerAgentEmail && <AddEmailSellerAgentWyoming isSellerAgentEmail={isSellerAgentEmail} setIsSellerAgentEmail={setIsSellerAgentEmail} agentsData={allSellerAgentData} userAuthKey={userAuthKey} source={source} offerId={offerId} openFor={(role === "SELLER") ? "SELLER_AGENT" : "BUYER_AGENT"} setCallPropertyDocsApi={setCallPropertyDocsApi} />}

      {<div style={{ maxHeight: "550px", overflow: "hidden", overflowY: "auto", padding: "5px 10px 5px 5px", marginTop: "-10px" }}>
        {loadOpacityLoader || addEmailLoading || getIndividualTransactionLoading ? (
          <div style={{ width: "100%", minHeight: "500px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Spin size="large" />
          </div>
        ) : (
          <div>
            {propertDocsLoading || personDocsLoading || (source === "TRANSACTION_CALENDAR" && getTransactionLaneLoading) ? (
              <div style={{ height: "200px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Spin size="medium" />
              </div>
            ) : (
                  <div style={{ overflowX: "auto", paddingBottom: isSmallScreen ? "10px" : "20px" }}>
                  {showTextArea && (
                      <div className={styles.addEmailForm}>
                        <Form form={form} onFinish={handleEmailAddress}>
                          <div style={{ display: "flex", width: "100%" }}>
                            <Form.Item style={{ display: "flex", justifyContent: "center", cursor: "pointer" }} onClick={() => setShowClientListModal(true)}>
                              <Tooltip title="Add Existing Contact" trigger={["click", "hover"]}>
                                <TiContacts style={{ fontSize: "35px" }} />
                              </Tooltip>
                            </Form.Item>

                            <Form.Item name="fullName" style={{ width: "30%", marginRight: "8px" }}>
                              <div className="customForm">
                                <Input rows={1} placeholder="Enter Name" onChange={handleReadOnlyNameChange} value={newState.fullName || ""} style={{ resize: "none", width: "100%" }} />
                              </div>
                            </Form.Item>

                            <Form.Item
                              name="email"
                              rules={[{ required: true, type: "email", message: "Please enter a valid email address" }]}
                              style={{ width: "90%", marginRight: "8px" }} // Larger proportion for the email box
                            >
                              <div className="customForm">
                                <Input placeholder="Enter email address" onChange={handleReadOnlyEmailChange} value={newState.email || ""} type="email" style={{ resize: "none", width: "100%" }} />
                              </div>
                            </Form.Item>
                            <Form.Item
                              name="email"
                              style={{ width: "15%" }} // Larger proportion for the email box
                            >
                              <div>
                                <Button type="primary" htmlType="submit" disabled={!newState?.email || !newState?.fullName}>
                                  Add
                                </Button>
                              </div>
                            </Form.Item>
                          </div>
                        </Form>
                      </div>
                    )}
                {clientsArray?.length ? (
                  <>
                    <div className={styles.groupLabel}>{`Recipient${clientsArray?.length > 1 ? "s" : ""}`}</div>
                    {clientsArray?.map((seller) => (
                      <div key={seller?._id} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                        {!seller?.isCorp && <NormalPersonDetails person={seller} />}
                        {seller.isCorp && <CorporationCheckbox corporation={seller} />}
                      </div>
                    ))}
                  </>
                ) : null}
                {["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT"].includes(source) && (
                  <>
                    {["SELLING_RTD", "CONTRACT_NAV_SELLER_AGENT"].includes(source) && allBuyerAgentData?.length > 0 && (
                      <>
                        <div className={styles.flexContatiner} style={{ marginTop: "10px" }}>
                          <Checkbox checked={selectedPersonsState?.agents} onChange={(e) => handleGroupCheckboxSelcted({ agents: e.target.checked })}></Checkbox>
                          <div className={styles.groupLabel}>{`Buyer Agent${allBuyerAgentData.length > 1 ? "s" : ""}`}</div>
                        </div>
                        <RecipientList data={allBuyerAgentData} />
                      </>
                    )}
                    {source === "CONTRACT_NAV_BUYER_AGENT" && allSellerAgentData?.length > 0 && (
                      <>
                        <div className={styles.flexContatiner} style={{ marginTop: "10px" }}>
                          <Checkbox checked={selectedPersonsState.agents} onChange={(e) => handleGroupCheckboxSelcted({ agents: e.target.checked })}  disabled={allSellerAgentData?.every(agent => !agent?.email)}></Checkbox>
                          <div className={styles.groupLabel}>{`Seller Agent${allSellerAgentData.length > 1 ? "s" : ""}`}</div>
                          {allSellerAgentData.some(agent => !agent?.email) && (
                                  <Button
                                    type="primary"
                                    size="small"
                                    style={{marginLeft:"5px"}}
                                    onClick={() => handleAddEmailClick(allSellerAgentData)}
                                  >
                                    Add Email
                                  </Button>
                                )}

                        </div>
                        <RecipientList data={allSellerAgentData} />
                      </>
                    )}
                    {(combinedTitleCompanyData?.titleRepsData?.length > 0 || combinedTitleCompanyData?.affiliatesData?.length > 0) && (
                      <Collapse ghost accordion defaultActiveKey={["1"]} style={{ marginLeft: "-12px" }}>
                        <Panel
                          header={
                            <div className={styles.groupLabel} style={{ marginBottom: "-15px" }}>
                              Title Company Reps & Affiliates
                            </div>
                          }
                          key="1"
                        >
                          <GroupedRecipientList isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} combinedTitleCompanyData={combinedTitleCompanyData} selectedPersonsState={selectedPersonsState} setSelectedPersonsState={setSelectedPersonsState} handleGroupCheckboxSelcted={handleGroupCheckboxSelcted} />
                        </Panel>
                      </Collapse>
                    )}
                  </>
                )}
                {["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT"].includes(source) && isClientDoc && combinedClientsData?.combinedSameSideAgents?.length > 0 && (
                  <div style={{ marginTop: "10px" }}>
                    <GroupedRecipientList combinedSameSideAgents={combinedClientsData?.combinedSameSideAgents} selectedPersonsState={selectedPersonsState} setSelectedPersonsState={setSelectedPersonsState} handleGroupCheckboxSelcted={handleGroupCheckboxSelcted} />
                  </div>
                )}

                {allContactAgentData?.length > 0 && (
                  <div style={{marginTop:"10px"}}>
                    <GroupedRecipientList type={"OTHER_AGENT"} combinedSameSideAgents={allContactAgentData} selectedPersonsState={selectedPersonsState} setSelectedPersonsState={setSelectedPersonsState} handleGroupCheckboxSelcted={handleGroupCheckboxSelcted} />
                  </div>
                )}
              </div>
            )}
            {isEmailModalVisible?.sendMultipleDoc && (
              <div
                style={{
                  marginTop: "-10px",
                  boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                }}
              >
                <Collapse ghost accordion defaultActiveKey={["1"]}>
                  <Panel
                    header={
                      <div className={styles.groupLabel} style={{ marginTop: "-3px" }}>
                        Document List
                      </div>
                    }
                    key="1"
                  >
                    <div>
                      <DocumentList role={role} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} RTDInitiator={RTDInitiater} isEmailModalVisible={isEmailModalVisible} contractAuthKey={userAuthKey} offerId={source === "SELLING_RTD" ? selectedData?.offerId : offerId} data={data} setData={setData} documentId={documentId} selectedData={selectedData} selectedStatus={role} rootDocData={rootDocData} screenSource={source} />
                    </div>
                  </Panel>
                </Collapse>
              </div>
            )}

            <div style={{ marginTop: "20px" }}>
              <SubjectLine form={subjectForm} data={data} source={source} clientDocs={clientDocs} selectedData={selectedData} rootDocData={rootDocData} propertyAddress={propertyAddress} />
            </div>

            <ContentEditable setEmail_templatevisible={setEmail_templatevisible} selectedtext={selectedtext} handleInput={handleInput} emailList={emailList} setEmailList={setEmailList} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} />

            <div style={{ marginTop: isSmallScreen ? "40px" : isMediumScreen ? "15px" : "10px", display: "flex" }}>
              <Checkbox checked={emailSignatureId.isDefault} onChange={(e) => setEmailSignatureId({ ...emailSignatureId, isDefault: e.target.checked })}  style={{ fontSize: isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px" }} disabled={!emailSignData || emailSignData?.length === 0}></Checkbox>
              <div className={styles.emailSignature}> Include Email Signature</div>
              <Select
                value={emailSignatureId._id} // Use value instead of defaultValue
                style={{ width: isSmallScreen ? 150 : 200, marginLeft: "5px", marginBottom: "20px" }}
                loading={emailSignLoading}
                onChange={(value) => handleSelectChange(value)}
                disabled={!emailSignatureId.isDefault}
              >
                {emailSignData &&
                  emailSignData?.length &&
                  emailSignData?.map((el, ind) => (
                    <Option key={ind} value={el?._id}>
                      {el?.title}
                    </Option>
                  ))}
              </Select>
              {emailSignatureId?.isDefault && (
                <Button style={{ fontSize: isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px" }} icon={<EyeOutlined />} onClick={() => setIspreview({ ...ispreview, signaturePreview: true })} type="link">
                Signature Preview
                </Button>
              )}
            </div>
            <div style={{ marginTop: "15px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            <Button type="primary" size={isSmallScreen ? "small" : "middle"} onClick={handleOpenEmailPreview} disabled={isButtonDisabled()}>
                  Email Preview
                </Button>
              <Button type="primary" size={isSmallScreen ? "small" : "middle"} disabled={isButtonDisabled()} onClick={() => handleSend()}>
                Send
              </Button>
            </div>
          </div>
        )}
      </div>}
    </>
  );
};

export { SendEmailModal };
